
(() => {
  if (window.brentosBundleTrackingInitialized) return;

  const bundleSection = document.querySelector(
    '[data-brentos-bundle][data-collection-handle]'
  );

  if (!bundleSection) return;

  window.brentosBundleTrackingInitialized = true;

  const bundleSource = bundleSection.dataset.collectionHandle;
  const attributeName = 'Bundle Builders Used';
  const root = window.Shopify?.routes?.root || '/';

  const cartUrl = `${root}cart.js`;
  const updateUrl = `${root}cart/update.js`;

  const originalFetch = window.fetch;
  let trackingQueue = Promise.resolve();

  async function getCart() {
    const response = await originalFetch(cartUrl, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Could not read cart');
    }

    return response.json();
  }

  async function updateTracking(value) {
    const response = await originalFetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [attributeName]: value
        }
      })
    });

    if (!response.ok) {
      throw new Error('Could not update bundle tracking');
    }
  }

  async function recordBundleSource() {
    const cart = await getCart();

    const existing = String(
      cart.attributes?.[attributeName] || ''
    )
      .split(',')
      .map(value => value.trim())
      .filter(Boolean);

    if (existing.includes(bundleSource)) return;

    existing.push(bundleSource);

    await updateTracking(existing.join(', '));
  }

  async function clearTrackingIfCartEmpty() {
    const cart = await getCart();

    if (
      cart.item_count === 0 &&
      cart.attributes?.[attributeName]
    ) {
      await updateTracking('');
    }
  }

  function queueTracking(task) {
    trackingQueue = trackingQueue
      .catch(() => {})
      .then(task)
      .catch(error => {
        console.warn('Brentos bundle tracking:', error);
      });
  }

  window.fetch = function(...args) {
    const input = args[0];

    const url = typeof input === 'string'
      ? input
      : input?.url || '';

    const method = String(
      args[1]?.method || input?.method || 'GET'
    ).toUpperCase();

    const isCartAdd =
      /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url) &&
      method === 'POST';

    const isCartChange =
      /\/cart\/(change|update|clear)(?:\.js)?(?:[?#]|$)/.test(url) &&
      method !== 'GET';

    const result = originalFetch.apply(this, args);

    if (isCartAdd || isCartChange) {
      result.then(response => {
        if (!response.ok) return;

        if (isCartAdd) {
          queueTracking(recordBundleSource);
        } else {
          queueTracking(clearTrackingIfCartEmpty);
        }
      }).catch(() => {});
    }

    return result;
  };

  // Clean up any tracking left on an empty cart.
  queueTracking(clearTrackingIfCartEmpty);

  // Recheck when returning to the bundle page.
  window.addEventListener('pageshow', () => {
    queueTracking(clearTrackingIfCartEmpty);
  });

})();
